import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { EDEditor } from '../lib/ed/editor';
import { cSessionGetEventView } from '../lib/mdl/c-event-admin';
import { CUserAdminView, cUserAdminViewGet } from '../lib/mdl/c-user-admin';
import { MChannel } from '../lib/mdl/m-message';
import { MContext, MEmailTemplate, MInboxTemplate, MPushTemplate, MSMSTemplate, MTemplate, mTemplateSendCustom, mTemplateSendTest, m_templates } from '../lib/mdl/m-template';
import { the_alt_token, the_user } from '../lib/me/login';
import { UIButton, makeActionButton } from '../lib/ui/component/button';
import { uiInitCodeEditor } from '../lib/ui/component/codeeditor';
import { UIDialog } from '../lib/ui/component/dialog';
import { UII18NInput } from '../lib/ui/component/i18n-input';
import { UITextInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UISelect } from '../lib/ui/component/select';
import { UITable, UITableDefinition } from '../lib/ui/component/table';
import { UITab, UITabs } from '../lib/ui/component/tabs';
import { uiToast } from '../lib/ui/component/toast';
import { UICheckbox, UIFlagsToggles, UISwitch } from '../lib/ui/component/toggle';
import { addTooltip } from '../lib/ui/component/tooltip';
import { showWarning } from '../lib/ui/component/warning';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIRelPos, UIValue } from '../lib/ui/types';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $on } from '../lib/y/events';
import { $form, YForm } from '../lib/y/form';
import { YLanguage, yGetI18N } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { yCopy } from '../lib/y/object';
import { $time } from '../lib/y/time';
import { YCountryId, YFlags, YId } from '../lib/y/types';
import { AdminEmailEditor } from './email_editor';
import { AdminPushEditor } from './push_editor';
import { AdminSmsEditor } from './sms_editor';

const language_values: UIValue<YLanguage>[] = [{ key: 'en', name: 'EN' }, { key: 'sv', name: 'SV' }, { key: 'de', name: 'DE' }];
const country_values: UIValue<YCountryId>[] = [{ key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }];
const channel_values: UIValue<MChannel>[] = [{ key: 'email', name: 'Email' }, { key: 'push', name: 'Push' }, { key: 'sms', name: 'SMS' }];

if(xavis_experiments)
    channel_values.push({ key: 'inbox', name: 'Inbox' });

class SendTemplateDialog extends UIDialog {
    constructor(template: MTemplate) {
        super({ close: true, classes: 'm-500' });

        const email = new UITextInput({ required: true });
        email.value = the_user!.email!;
        const language = new UISelect(language_values, { required: true });
        language.value = the_user!.language;
        const country = new UISelect(country_values, { required: true });
        country.value = the_user!.country;

        const form = $form({ email, language, country });

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Send message'),
            new UILabeled(email, { above: 'User email' }),
            new UILabeled(language, { above: 'Language' }),
            new UILabeled(country, { above: 'Country' }),
            $el.DIV('l-button-row', [
                new UIButton({ title: "Cancel", classes: 'm-round m-compact', on_click: () => { this.dismiss(null) } }),
                new UIButton({
                    title: "Send", classes: 'm-round m-compact m-hollow', on_click: () => {
                        if(!form.validate()) return;
                        return mTemplateSendTest(template.id, form.value).then(() => {
                            this.dismiss(true);
                        }, uiToast)
                    }
                })
            ])
        ]));
    }
}

class TemplateInfoTab extends UIView {
    constructor(template: MTemplate | undefined) {
        super('div', 'tl-admin-page');

        const is_hidden = new UISwitch;
        const name = new UITextInput({ required: true });
        const channel = new UISelect(channel_values, { required: true });
        const context_values: UIValue<MContext>[] = [{ key: 'user', name: 'User' }, { key: 'booking', name: 'Booking' }, { key: 'subscription', name: 'Subscription' }, { key: 'giftcard', name: 'Giftcard' }, { key: 'invite', name: 'Invite' }, { key: 'b2b_giftcard', name: 'B2B Gift Card' }, { key: 'producer', name: 'Producer' }, { key: 'producer_invoice', name: 'Producer invoice' }, { key: 'producer_invite', name: 'Producer invite' }, { key: 'producer_event', name: 'Producer event info' }, { key: 'booking_list', name: 'Booking list' }, { key: 'reset_password', name: 'Reset password' }, { key: 'purchase', name: 'Purchase' }, { key: 'otp', name: 'OTP' }];
        const context = new UISelect(context_values, { required: true });
        const resource_id = new UITextInput({ undefined_if_empty: true });
        const languages = new UIFlagsToggles(language_values, v => new UICheckbox({ key: v.key, title: v.name }), { classes: 'l-toggle-row', required: true })

        const form = $form({ is_hidden, name, channel, context, resource_id, languages });

        const section = $el.FORM('ui-section w-form l-form', [
            xavis_experiments && new UILabeled(is_hidden, { before: 'Hidden' }),
            new UILabeled(name, { above: 'Name' }),
            new UILabeled(channel, { above: 'Channel' }),
            new UILabeled(context, { above: 'Context' }),
            new UILabeled(resource_id, { above: 'Resource ID' }),
            new UILabeled(languages, { above: 'Languages' }),
        ]);

        if(template) {
            form.value = template;
            channel.disabled = true;

            // this.classList.add('m-sidebar');
            // const sidebar = $el.DIV('tl-sidebar')

            // sidebar.ui_add([
            //     $el.DIV('tl-sidebar-heading', 'Routes to this page')
            // ]);

            // $tl.routes.getAll().then(routes => {
            //     routes = routes.filter(r => r.target_type == 'page' && r.target_id == page.id);

            //     if(routes.length) {
            //         for(const r of routes) {
            //             sidebar.ui_add($el.B(r.path));
            //         }
            //     } else {
            //         sidebar.ui_add($el.B('No routes'));
            //     }

            //     sidebar.ui_add(new UIButton({ kind: 'k-text', title: 'New route', on_click: () => {
            //         $location.push({ transient: new admin_routes.RouteScreen(undefined, { page: page.id }) });
            //     }}));
            // });

            // this.ui_add(sidebar);
        } else {
            channel.value = 'email';
            context.value = 'user';
            languages.value = { en: true, sv: true, de: true };
        }

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                return m_templates.upsert(template?.id, form.value).then(() => {
                    if(template)
                        uiToast('Template saved');
                    else
                        $location.pop();
                }, uiToast);
            }
        });

        addTooltip(template ? 'Update' : 'Create', button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.ui_add([
            section,
            button
        ]);
    }
}

class TemplateEmailContentTab extends UIView {
    constructor(template: MEmailTemplate) {
        super('div', 'tl-admin-page m-sidebar m-left-sidebar m-fixed');

        const editor = new AdminEmailEditor(template.context, template.name, Object.keys(template.languages), 'r-main');
        const form = $form({ content: editor.form })

        if(!template.content) {
            $log('app', 'Creating email content');
            template.content = {
                from: 'noreply',
                subject: {},
                header: { image: '', button: false },
                footer: { unsubscribe: false },
                sections: [{ background: '#ffffff', blocks: [{ type: 'text', text: {}, columns: false }] }],
                decoration: 'none',
                schema: false,
                attachments: []
            };
        }

        form.value = template;

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                m_templates.update(template.id, form.value).then(() => {
                    uiToast('Template saved');
                }, uiToast);
            }
        });

        addTooltip('Save', button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.ui_add([
            editor.toolbar,
            editor,
            $el.DIV('tl-sidebar m-editor l-v m-left', [
                editor.tree
            ]),
            $el.DIV('tl-sidebar m-editor l-v', [
                editor.properties_container,
                $el.S(),
                $el.DIV('s-small'),
                editor.fields
            ]),
            button
        ]);
    }
}

class TemplatePushContentTab extends UIView {
    constructor(template: MPushTemplate) {
        super('div', 'tl-admin-page m-sidebar m-fixed');

        const editor = new AdminPushEditor(template.context, template.name, Object.keys(template.languages), 'r-main');
        const form = $form({ content: editor.form })

        if(!template.content) {
            template.content = {
                title: {},
                body: {}
            };
        }

        form.value = template;

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                m_templates.update(template.id, form.value).then(() => {
                    uiToast('Template saved');
                }, uiToast);
            }
        });

        addTooltip('Save', button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.ui_add([
            editor.toolbar,
            editor,
            $el.DIV('tl-sidebar m-editor l-v', [
                editor.properties_container,
                $el.S(),
                $el.DIV('s-small'),
                editor.fields
            ]),
            button
        ]);
    }
}

class TemplateSMSContentTab extends UIView {
    constructor(template: MSMSTemplate) {
        super('div', 'tl-admin-page m-sidebar m-fixed');

        const editor = new AdminSmsEditor(template.context, template.name, Object.keys(template.languages), 'r-main');
        const form = $form({ content: editor.form })

        if(!template.content) {
            template.content = {
                body: {}
            };
        }

        form.value = template;

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                m_templates.update(template.id, form.value).then(() => {
                    uiToast('Template saved');
                }, uiToast);
            }
        });

        addTooltip('Save', button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.ui_add([
            editor.toolbar,
            editor,
            $el.DIV('tl-sidebar m-editor l-v', [
                editor.properties_container,
                $el.S(),
                $el.DIV('s-small'),
                editor.fields
            ]),
            button
        ]);
    }
}

class TemplateEmailPreviewTab extends UIView {
    constructor(template: MEmailTemplate) {
        super('div', 'tl-admin-page m-sidebar m-fixed');

        let main = $el.DIV('r-main');
        const language = new UISelect(language_values);
        const country = new UISelect(country_values);

        const sidebar = $el.DIV('tl-sidebar', $el.DIV('l-form', [
            new UILabeled(language, { above: 'Language' }),
            new UILabeled(country, { above: 'Country' }),
        ]))

        this.ui_add([main, sidebar]);

        const render = () => {
            main.replaceWith(main = $el.IFRAME(`/docs/m/template/${template.id}/preview?token=${the_alt_token}&lang=${language.value}&country=${country.value}`, 'r-main'));
        }

        language.value = 'en';
        country.value = 'SE';

        render();

        $on(language, 'value', render);
        $on(country, 'value', render);
    }
}

class TemplateInboxContentTab extends UIView {
    constructor(template: MInboxTemplate) {
        super('div', 'tl-admin-page m-sidebar');

        const sidebar = $el.DIV('tl-sidebar');

        const body = new UII18NInput(new UITextInput({ lines: 10 }), { required: true });

        const form = $form({ content: $form({ body }) });

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(body, { above: 'Body' }),
        ]);

        form.value = template;

        const button = new UIButton({
            icon: UIIcon.THUMBS_UP, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                m_templates.update(template.id, form.value).then(() => {
                    $location.pop();
                }, uiToast);
            }
        });

        addTooltip('Save', button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.ui_add([section, sidebar, button]);
    }
}

class TemplateJSONTab extends UIView {
    constructor(template: MTemplate) {
        super('div', ['tl-admin-page', 'm-fixed', 'w-block']);

        const editor_element = $el.DIV(['r-main']);

        let editor: AceAjax.Editor | undefined;

        uiInitCodeEditor().then(() => {
            editor = ace.edit(editor_element);
            editor.setShowFoldWidgets(false);
            editor.setShowPrintMargin(false);
            editor.renderer.setShowGutter(false);
            editor.session.setMode('ace/mode/json');
            editor.setValue(JSON.stringify(template.content, null, 2), 0);
            editor.focus();
        });

        this.ui_add(editor_element);
    }
}

export class AdminTemplateScreen extends UIScreen {
    constructor(private _template_id?: YId) {
        super();
        this.title = _template_id ? 'Template' : 'New template';
    }

    protected override async fillContent(content: UIViewSpec) {
        content.classList.add('tl-tabs');

        const template = this._template_id && await m_templates.get(this._template_id);
        const tabs: UITab[] = [{ title: 'Info', view: () => new TemplateInfoTab(template) }];

        if(template) {
            this.title = template.name;

            if(template.channel == 'email') {
                tabs.push(
                    { title: 'Content', view: () => new TemplateEmailContentTab(template) },
                    { title: 'Preview', view: () => new TemplateEmailPreviewTab(template) }
                );
            }

            if(template.channel == 'inbox') {
                tabs.push({ title: 'Content', view: () => new TemplateInboxContentTab(template) });
            }

            if(template.channel == 'push') {
                tabs.push({ title: 'Content', view: () => new TemplatePushContentTab(template) });
            }

            if(template.channel == 'sms') {
                tabs.push({ title: 'Content', view: () => new TemplateSMSContentTab(template) });
            }

            tabs.push({ title: 'JSON', view: () => new TemplateJSONTab(template!) });
        }

        content.ui_add(new UITabs(tabs));
    }
}

export class AdminTemplatesScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const all_templates = await m_templates.getAll();

        const doSearch = () => {
            let templates = all_templates;
            if(!xavis_experiments)
                templates = templates.filter(t => t.channel == 'email' || t.channel == 'push' || t.channel == 'sms').filter(t => !t.is_hidden);

            count.number = templates.length;
            source.data = templates;
        }

        const count = new ABObjectCount('templates');

        const filter_bar = new ABFilterBar({
            right_content: [count],
            no_header: true
        });

        const def = new UITableDefinition<MTemplate>();

        def.addValue(p => p.channel, { title: 'Channel', width: -120 });
        def.addValue(t => t.name, { title: 'Name', width: 200 });
        def.addValue(p => p.resource_id || '', { title: 'Resource id', width: -260 });
        def.addValue(p => p.context, { title: 'Context', width: -120 });

        if(xavis_experiments) {
            // def.addValue(p => p.removed, $fmt.CHECKMARK, { title: 'Removed', width: -80 });
            def.addValue(e => $time(e.updated_at), $fmt.DATE('d MMM yyyy'), { id: 'updated_at', title: 'Updated at', width: -120, optional: true });
            def.addValue(p => p.id, { title: 'ID', width: -200 });
        }

        def.addButtons([
            {
                icon: UIIcon.TRASH_CAN, tooltip: 'Delete', when: xavis_experiments, action: item => {
                    return showWarning({ text: "Are you sure you want to delete this template?" }).then(() => {
                        return m_templates.remove(item.id).then(doSearch);
                    });
                }
            },
            {
                icon: UIIcon.COPY, tooltip: 'Duplicate', action: item => {
                    item = yCopy(item);
                    item.name = 'Copy of ' + item.name;
                    item.resource_id = '';
                    m_templates.insert(item).then(() => {
                        $location.reload();
                    }, uiToast);
                }
            },
            {
                icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
                    $location.push('template', { template_id: item.id });
                }
            },
            {
                icon: UIIcon.PAPER_PLANE, tooltip: 'Send', action: item => {
                    new SendTemplateDialog(item).present();
                }
            }
        ], { width: -125 });

        def.controller = row => {
            if(row.item.is_hidden)
                row.classList.add('tl-standby-row');
        };

        def.preference_prefix = 'templates';

        const source = new YArrayDataSource<MTemplate>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wide', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New template', () => { $location.push('template') })
        ]);

        doSearch();
        this.onViewDidReappear = doSearch;
    }
}

export class AdminSendMessageScreen extends UIScreen {
    constructor(private _channel: MChannel, private _session_id: YId | undefined, private _user_id: YId | undefined, private _languages: YFlags<YLanguage>) {
        super();
        this.title = 'Send email';
        this.classList.add('m-fixed');
    }

    protected override async fillContent(content: UIViewSpec) {
        content.classList.add('l-v');

        let button_text: string;
        let name: string;
        let context: MContext;

        if(this._session_id) {
            const session = await cSessionGetEventView(this._session_id);
            name = `Message for session ${session.id}`;
            context = 'booking';
            button_text = `Send to bookings of ${yGetI18N(session.event.name)}`;
        } else if(this._user_id) {
            const user = await cUserAdminViewGet(this._user_id);
            name = `Message for user ${this._user_id}`;
            context = 'user';
            button_text = `Send to ${user.email}`;
        } else {
            throw 'Invalid arguments';
        }

        const channel = this._channel;
        let editor: EDEditor<any, any, any>;
        let form: YForm;

        if(channel == 'push') {
            const push_editor = new AdminPushEditor(context, 'Custom push notification', Object.keys(this._languages), 'i-fill');
            form = $form({ content: push_editor.form })

            push_editor.form.value = {
                title: {},
                body: {},
            }

            editor = push_editor;
        } else if(channel == 'sms') {
            const sms_editor = new AdminSmsEditor(context, 'Custom SMS', Object.keys(this._languages), 'i-fill');
            form = $form({ content: sms_editor.form })

            sms_editor.form.value = {
                title: {},
                body: {},
            }

            editor = sms_editor;
        } else {
            const email_editor = new AdminEmailEditor(context, 'Custom email', Object.keys(this._languages), 'i-fill');
            form = $form({ content: email_editor.form })

            email_editor.form.value = {
                subject: {},
                header: { image: '', button: false },
                footer: { unsubscribe: false },
                sections: [{ background: '#ffffff', blocks: [{ type: 'text', text: {}, columns: false }] }],
                decoration: 'none'
            }

            editor = email_editor;

            this.addSidebar(UIRelPos.Left, 210, 'l-v m-no-padding').ui_add(editor.tree);
        }

        const button = new UIButton({
            icon: UIIcon.PAPER_PLANE, kind: 'k-square', classes: 'm-round ui-action-button', on_click: () => {
                if(!form.validate()) return;

                const value = form.value as Partial<MTemplate>;
                value.channel = channel;
                value.context = context;
                value.languages = this._languages;
                value.name = name;

                return mTemplateSendCustom(this._session_id, this._user_id, value).then(() => {
                    uiToast('Message sent');
                    $location.pop();
                }, uiToast)
            }
        });

        addTooltip(button_text, button, { offset: 8, hover: button, position: UIRelPos.Above });

        this.addSidebar(UIRelPos.Right, 280, 'l-v').ui_add([
            editor.properties_container,
            $el.S(),
            $el.DIV('s-small'),
            editor.fields
        ]);

        content.ui_add([
            editor.toolbar,
            editor,
            button
        ]);
    }
}

export class AdminSendMessageDialog extends UIDialog {
    constructor(user?: CUserAdminView, session_id?: YId) {
        super({ close: true });

        const languages = new UIFlagsToggles(language_values, v => new UICheckbox({ key: v.key, title: v.name }), { classes: 'l-toggle-row', required: true })
        const channel = new UISelect(channel_values, { required: true });
        channel.value = 'email';

        if(user)
            languages.value = { [user.language]: true }

        this.content.ui_add($el.DIV('w-block l-form m-center', [
            $el.H2('title', 'Send message'),
            channel,
            languages,
            $el.DIV('l-button-row', [
                new UIButton({ title: "Cancel", classes: 'm-round m-compact', on_click: () => { this.dismiss(null) } }),
                new UIButton({
                    title: "Choose", classes: 'm-round m-compact m-hollow', on_click: () => {
                        if(!$form.validate(languages)) return;
                        this.dismiss(true);
                        $location.push('send_message', { channel: channel.value, user_id: user?.id, session_id, languages: languages.value });
                    }
                })
            ])
        ]));
    }
}
